export const verification = {
    title: '本人確認',
    infomation: '個人情報。',
    content:
        '入力されたすべての情報があなたの本人確認書類と一致していることを確認してください。確認を押した後は情報を変更してはいけない。',
    selectInfo: '本人確認書類の種類を選択',
    passport: 'パスポート',
    identity: '公民証明書',
    countries: '国を選択',
    numberCmt: '公民証明書番号',
    numberPassport: 'パスポート番号',
    identityTitle: '公民証明書カードの写真。',
    passportTitle: 'パスポートカードの写真。',
    line1: '本人確認書類の写真は鮮明で詳細なものであることを確認してください。',
    line2: 'サイズが10MBまでの画像を使用してください',
    line3: 'JPG、JPEG、PNG形式の画像をご利用ください。',
    label1: '十分な詳細。',
    label2: '欠落してはいけない',
    label3: 'ぼやけていけない',
    label4: '影なし',
    contentBefore: '正面をアップロード',
    contentAfter: '裏面をアップロード',
    imageBefore: '正面',
    imageAfter: '裏面',
    passportLabel: 'パスポート写真',
    portraitLabel: '自撮り写真',
    back: '戻る',
    nextStep: '続行',
    portraitTitle: '自撮り写真。',
    portraitContent1:
        '帽子をかぶったり、メガネやフィルターを使用したりせず、またはフィルターを使用し、十分な光を当ててください。 ',
    portraitContent2: 'サイズが10MBまでの画像を使用してください。 ',
    portraitContent3: 'JPG、JPEG、PNG形式の画像をご利用ください。',
    portraitContent4Cccd:
        '公民証明書と、撮影された日付が記載された紙を持ったあなたの顔の鮮明な写真を撮り、"ste.sbgroup.finance"を記入します。',
    portraitContent4Passport:
        'パスポートと、撮影された日付が記載された紙を持ったあなたの顔の鮮明な写真を撮り、"ste.sbgroup.finance"を記入します。',
    contentPortrait: '写真をアップロード',
    completeTitle: '本人確認にご協力いただきありがとうございます！',
    completeContent: '購入する前に管理者が確認するまでお待ちください',
    gotoHome: 'ホームページへ',
    requiredImage: '空白のままにしてはいけない',
    required: {
        passportLabel: 'パスポート写真は空白のままにしてはいけない',
        portraitLabel: '自撮り写真は空白のままにしてはいけない',
        imageBefore: '正面は空白のままにしてはいけない',
        imageAfter: '裏面は空白のままにしてはいけない',
    },
    validateMaxSizeImage: '10MB未満のファイルのみをアップロードしてください。',
    validateMinSizeImage: '画像のサイズは少なくとも 10kb である必要があります',
    validateImage: 'jpg、png.jpeg画像のみでアップロードできます',
    placeholderCmt: '例： B2412111',
};
